import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import BBUserWebsite from './BBUserWebsite';
import BBAdminPanel from './BBAdminPanel';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<BBUserWebsite />} />
        <Route path="/adminbw" element={<BBAdminPanel />} />
      </Routes>
    </Router>
  );
}

export default App;
